module.exports = __webpack_public_path__ + "assets/fb909244dca3ab958234a6f75bd8b57e.mp3";